package dev.lingvo.shared.screenshots

import dev.lingvo.shared.screenshots.frames.DeviceFrames
import dev.lingvo.shared.screenshots.frames.VectorFrames
import dev.lingvo.shared.screenshots.render.Renderer
import dev.lingvo.shared.screenshots.render.ShotRenderer
import dev.lingvo.shared.screenshots.text.CaptionFitter
import dev.lingvo.shared.screenshots.text.DefaultFontResolver
import dev.lingvo.shared.screenshots.text.FontResolver
import dev.lingvo.shared.screenshots.text.RuleSegmenter
import dev.lingvo.shared.screenshots.text.ScriptResolver
import dev.lingvo.shared.screenshots.text.Scripts
import dev.lingvo.shared.screenshots.text.Segmenter
import dev.lingvo.shared.screenshots.text.TextFitter

/** Keeps previews and exports on the same production text, font and frame implementations. */
object ScreenshotEngine {
    /** Real fitting keeps legibility-floor refusals consistent across all entry points. */
    val fitter: CaptionFitter = TextFitter

    /** Shared script rules align font selection with the fitter's typography policy. */
    val scripts: ScriptResolver = Scripts

    /** Catalog resolution keeps exported font stacks independent of editor defaults. */
    val fonts: FontResolver = DefaultFontResolver

    /** Vector geometry preserves capture aspect in every supported silhouette. */
    val frames: DeviceFrames = VectorFrames

    /** Deterministic segmentation gives non-browser callers an explicit fallback. */
    val ruleSegmenter: Segmenter = RuleSegmenter

    /** Each rendering thread receives its own mutable fit cache instead of sharing editor state. */
    fun renderer(): ShotRenderer = Renderer(fitter, frames)
}
